export default {
  en: {
    'components.colour-picker.label': 'Colour',
  },
};
